<template>
  <div v-if="hasAvatar" class="avatar">
    <img class="rounded-full border border-gray-100 shadow-sm" :src="avatarUrl">
  </div>
  <div v-else class="avatar bg-info-300">
    <i class="fas fa-user text-white"></i>
  </div>
</template>
<script>
export default {
  name: 'UserAvatar',

  props: {
    avatarUrl: {
      type: String,
      default: ''
    }
  },

  computed: {
    hasAvatar() {
      return Boolean(this.avatarUrl)
    }
  },
}
</script>

<style scoped>
.avatar {
  @apply rounded-full;
  @apply h-8;
  @apply w-8;
  @apply flex;
  @apply items-center;
  @apply justify-center;
}
</style>
